// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomThreadPostDelete
 */
export interface ClassroomThreadPostDelete {
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadPostDelete
     */
    post: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadPostDelete
     */
    classroom: string;
}

export function ClassroomThreadPostDeleteFromJSON(json: any): ClassroomThreadPostDelete {
    return {
        'post': json['post'],
        'classroom': json['classroom'],
    };
}

export function ClassroomThreadPostDeleteToJSON(value?: ClassroomThreadPostDelete): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'post': value.post,
        'classroom': value.classroom,
    };
}


